<template>
  <div>
    <div class="messageContainer" @mouseover="isHovered = true" @mouseleave="isHovered = false">
      <div v-if="message.mainContent" class="message" style="white-space: pre-line" :style="elementStyle">
        <div v-if="areDetailsShown" v-show="isHovered" class="logContainer" :style="elementStyle">
          <Logger
            :intent-analysed="intentAnalysed"
            :action-deduced="actionDeduced"
            :context="context"
            :intent-info="config"
            :is-hovered="isHovered"
          />
        </div>
        <img
          :src="isImageUrl ? message.attachments[0].url : defaultImage"
          @load="scrollToBottom(message.isNewMessage)"
        />
        <p>{{ message.attachments[0].name }}</p>
      </div>
      <LoggerLinks
        :intent-analysed="intentAnalysed"
        :action-deduced="actionDeduced"
        :are-details-shown="areDetailsShown"
        :assistant-id="assistantId"
        :assistant-slug="assistantSlug"
        @openUrl="openUrl"
      />
      <div v-show="isHovered" class="messageTime">{{ formatDate(message.sentTime, locale, $t) }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate, areDetailsShown, scrollToBottom } from '../../lib/utils'
import Logger from './Logger'
import LoggerLinks from './LoggerLinks'
import config from '../../config/messages'

export default {
  name: 'Message',
  components: {
    Logger,
    LoggerLinks
  },
  props: {
    message: { type: Object, required: true },
    intentAnalysed: { type: Object, default: null },
    context: { type: Object, default: null },
    actionDeduced: { type: Object, default: null },
    isShowLogs: { type: Boolean, default: false },
    elementStyle: { type: [Object, Boolean], default: null },
    assistantId: { type: String, required: true },
    assistantSlug: { type: String, required: true }
  },
  data: function () {
    return {
      config,
      isHovered: false,
      defaultImage: 'https://yelda-chat.s3.eu-west-3.amazonaws.com/images/file.png'
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    isImageUrl: function () {
      if (!this.message.attachments) {
        return false
      }

      const url = this.message.attachments[0].url.toLowerCase()
      return url.match(/\.(jpeg|jpg|gif|png)$/) != null
    },
    areDetailsShown: function () {
      return areDetailsShown(this.context, this.intentAnalysed, this.actionDeduced, this.isShowLogs)
    }
  },
  methods: {
    formatDate,
    scrollToBottom,
    openUrl(url) {
      this.$emit('openUrl', url)
    }
  }
}
</script>
